//@flow
import React, { Component } from 'react';
import { ToggleP, ToggleIcon, IconWrapperDiv } from './ToggleTextStyles';

type Props = {
  className: string,
  iconName?: string,
  text: string,
  activeText?: string,
  inActiveText?: string,
  toggleState: boolean,
  setToggleState: () => void
};

export default class ToggleText extends Component<Props> {
  handleClick = () => {
    this.props.setToggleState();
  };
  render() {
    return (
      <div className={this.props.className}>
        <IconWrapperDiv onClick={this.handleClick}>
          <ToggleIcon name={this.props.iconName} />
          <ToggleP>
            {this.props.toggleState
              ? this.props.activeText
              : this.props.inActiveText}{' '}
            {this.props.text}
          </ToggleP>
        </IconWrapperDiv>
      </div>
    );
  }
}
